import { render } from "./FeatureCard.vue?vue&type=template&id=616619bf&scoped=true"
import script from "./FeatureCard.vue?vue&type=script&lang=js"
export * from "./FeatureCard.vue?vue&type=script&lang=js"

import "./FeatureCard.vue?vue&type=style&index=0&id=616619bf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-616619bf"

export default script